import React, { Component } from "react";
import { connect } from "react-redux";
import { SET_TICKET_LIST_RELOAD } from "../../actions/types";

import HelpAndSupportHeader from "../CommonComponents/HelpAndSupportHeader";
import TumbnailImg from "./TumbnailImg";
import DisplayImage from "./DisplayImage";
import ErrorMessage from "../CommonComponents/ErrorMessage";

import UserDetails from "../UserDetails/UserDetails";
import attactment from "../../svg/additional.svg";

import api from "../../api/api";

class NewTicket extends Component {
  constructor(props) {
    super(props);
    this.state = {
      headerMessage: {
        title: "New Support Ticket",
        description: "Write a new ticket",
        backIcon: false,
        moreOptionhidden: true,
        searchOptionHidden: true,
      },
      submitBtnDisable: true,
      imgFiles: [],
      displayImage: false,
      imageNo: 0,
      fileToDisplay: null,
      displayErrorPopup: false,
    };
  }

  /**
   * this is for history or goback
   */
  goBack = () => {
    if (!this.state.displayImage) {
      this.props.history.goBack();
    } else {
      this.setState({
        displayImage: false,
      });
    }
  };

  goToSupport = () => {
    this.props.history.replace("/support");
  };

  onEnableSubmitBtn = () => {
    if (document.getElementById("ticketDesc").value.trim().length > 0) {
      this.setState({
        submitBtnDisable: false,
      });
    } else {
      this.setState({
        submitBtnDisable: true,
      });
    }
  };

  fileUploadClick = () => {
    document.getElementById("fileUpload").click();
  };

  getFileList = (event) => {
    if (event.target.files.length > 0) {
      this.setState({
        imgFiles: [...this.state.imgFiles, event.target.files[0]],
      });
    }
    document.getElementById("fileUpload").files = null;
  };

  onSubmitBtnClick = () => {
    const {
      userId,
      email,
      fName,
      name,
      mobile,
      city,
      countryCode,
      userIdv2,
      guestId,
    } = this.props;
    const playoId = userIdv2 || userId || guestId;
    api.displayMainLoader();
    this.setState({
      submitBtnDisable: true,
    });
  
    if (this.state.imgFiles.length === 0) {
      let dataToSend = {
        title: `Help Ticket: ${fName}`,
        description: document.getElementById("ticketDesc").value,
        imageArray: [],
      };
      api
        .createNewTicket(
          dataToSend,
          playoId,
          email,
          name,
          mobile,
          city,
          countryCode
        )
        .then((data) => {
          this.setState({
            submitBtnDisable: false,
          });
          this.props.ticketUpdated();
          api.displayHideLoader();
          this.goToSupport();
        })
        .catch((error) => {
          this.setState({
            displayErrorPopup: true,
          });
          api.displayHideLoader();
        });
    } else {
      console.log(this.state.imgFiles)
      let dataToSend = {
        title: `Help Ticket: ${fName}`,
        description: document.getElementById("ticketDesc").value,
        imageArray: this.state.imgFiles,
      };
      api
        .createNewTicketWithAttachments(
          dataToSend,
          playoId,
          email,
          name,
          mobile,
          city,
          countryCode
        )
        .then((data) => {
          this.setState({
            submitBtnDisable: false,
          });
          this.props.ticketUpdated();
          api.displayHideLoader();
          this.goToSupport();
        })
        .catch((error) => {
          console.log(error)
          this.setState({
            displayErrorPopup: true,
          });
          api.displayHideLoader();
        });
    }
  };

  onTumbnailClick = (no) => {
    --no;
    this.setState({
      displayImage: true,
      imageNo: no,
      fileToDisplay: this.state.imgFiles[no],
    });
  };

  deleteOption = (no) => {
    this.setState({
      displayImage: false,
      imgFiles: this.state.imgFiles.splice(no, -1),
    });
  };

  errorCloseCLick = () => {
    this.setState({
      displayErrorPopup: false,
    });
  };

  componentDidMount() {
    api.displayHideLoader();
  }

  render() {
    const { fName, email, guestId } = this.props;
    let i = 0;
    // return <UserDetails />;

    return (fName && email) || guestId ? (
      <div>
        {this.state.displayImage ? (
          <DisplayImage
            deleteOption={this.deleteOption.bind(this)}
            no={this.state.imageNo}
            image={this.state.fileToDisplay}
            displayDeleteBtn={true}
            back={this.goBack.bind(this)}
          />
        ) : (
          ""
        )}
        {this.state.displayErrorPopup ? (
          <ErrorMessage onCloseClick={this.errorCloseCLick.bind(this)} />
        ) : (
          ""
        )}
        <HelpAndSupportHeader
          displayMessage={this.state.headerMessage}
          back={this.goBack.bind(this)}
        />
        <div className="body-container">
          {/* <div className="ticket-box-container">
              <div className="ticket-box">
                <div className="ticket-box-title">TITLE</div>
                <input
                  type="text"
                  id="ticketTitle"
                  className="ticket-box-input"
                  placeholder="Give your ticket a title"
                  maxLength="64"
                  style={{ paddingLeft: 0 }}
                  onChange={this.onEnableSubmitBtn.bind(this)}
                />
              </div>
            </div> */}
          <div className="ticket-box-container" style={{ marginTop: "15px" }}>
            <div className="ticket-box">
              <div className="ticket-box-title">DESCRIPTION</div>
              <textarea
                id="ticketDesc"
                className="ticket-description-textarea"
                placeholder={
                  guestId
                    ? "Please add your mobile number and name along with the description of the issue in the message for our team to reach you"
                    : "Describe your message"
                }
                maxLength="512"
                style={{ paddingLeft: 0 }}
                onChange={this.onEnableSubmitBtn.bind(this)}
              />
            </div>
          </div>
          {this.state.imgFiles.map((image) => {
            return (
              <TumbnailImg
                image={image}
                key={++i}
                no={i}
                onTumbnailClick={this.onTumbnailClick.bind(this)}
                imageLink={false}
              />
            );
          })}
          <div
            className="ticket-attactment-icon-area"
            onClick={this.fileUploadClick.bind(this)}
          >
            <img src={attactment} alt="" className="ticket-attactment-icon" />
            <label className="ticket-attactment-label">
              Attach screenshot if required
            </label>
            <input
              type="file"
              id="fileUpload"
              hidden={true}
              onChange={this.getFileList.bind(this)}
              accept="image/*"
            />
          </div>
        </div>
        <div className="submit-btn-container">
          <input
            type="button"
            className="submit-btn"
            disabled={this.state.submitBtnDisable}
            onClick={this.onSubmitBtnClick.bind(this)}
            value="Submit Ticket"
          />
        </div>
      </div>
    ) : (
      <UserDetails />
    );
  }
}

const mapStateToProps = ({
  userId,
  email,
  name,
  fName,
  mobile,
  countryCode,
  city,
  userIdv2,
  guestId,
}) => ({
  userId,
  email,
  name,
  fName,
  mobile,
  countryCode,
  city,
  userIdv2,
  guestId,
});

const mapDispatchToProps = (dispatch) => {
  return {
    ticketUpdated: () => {
      dispatch({
        type: SET_TICKET_LIST_RELOAD,
        payload: true,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewTicket);



// WEBPACK FOOTER //
// ./src/components/Tickets/NewTicket.js